// if (!customElements.get('media-gallery')) {
//   customElements.define(
//     'media-gallery',
//     class MediaGallery extends HTMLElement {
//       constructor() {
//         super();
//         this.elements = {
//           liveRegion: this.querySelector('[id^="GalleryStatus"]'),
//           viewer: this.querySelector('[id^="GalleryViewer"]'),
//           thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
//         };

//         this.isVerticalScroll = this.classList.contains('vertical-scroll') && window.innerWidth >= 1025 && !this.closest('.quick-add-modal');

//         if (!this.elements.thumbnails) return;

//         this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));

//         this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
//           mediaToSwitch.querySelector('button')
//             .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target));
//         });

//         if (this.dataset.desktopLayout.includes('thumbnail') && this.isVerticalScroll) this.removeListSemantic();

//         // === Fix for horizontal scroll when no arrows ===
//         if (!this.isVerticalScroll && this.elements.thumbnails && !this.elements.thumbnails.querySelector('.arrow')) {
//           const slider = this.elements.thumbnails.slider;
//           if (slider) {
//             slider.style.overflowX = 'auto';
//             slider.style.scrollBehavior = 'smooth';
//             slider.style.cursor = 'grab';

//             let isDown = false;
//             let startX;
//             let scrollLeft;

//             slider.addEventListener('mousedown', (e) => {
//               isDown = true;
//               slider.classList.add('active');
//               startX = e.pageX - slider.offsetLeft;
//               scrollLeft = slider.scrollLeft;
//             });

//             slider.addEventListener('mouseleave', () => {
//               isDown = false;
//               slider.classList.remove('active');
//             });

//             slider.addEventListener('mouseup', () => {
//               isDown = false;
//               slider.classList.remove('active');
//             });

//             slider.addEventListener('mousemove', (e) => {
//               if (!isDown) return;
//               e.preventDefault();
//               const x = e.pageX - slider.offsetLeft;
//               const walk = (x - startX) * 1; // Adjust scroll speed if needed
//               slider.scrollLeft = scrollLeft - walk;
//             });
//           }
//         }
//       }

//       onSlideChanged(event) {
//         const thumbnail = this.elements.thumbnails.querySelector(
//           `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
//         );
//         this.setActiveThumbnail(thumbnail);
//       }

//       setActiveMedia(mediaId) {
//         const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) || this.elements.viewer.querySelector('[data-media-id]');

//         if (!activeMedia) return;

//         this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
//           element.classList.remove('is-active');
//         });
//         activeMedia?.classList?.add('is-active');

//         this.preventStickyHeader();

//         window.setTimeout(() => {
//           if (this.isVerticalScroll) {
//             activeMedia.parentElement.scrollTo({ top: activeMedia.offsetTop });
//           } else {
//             activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
//           }
//           const activeMediaRect = activeMedia.getBoundingClientRect();
//           if (activeMediaRect.top > -0.5) return;
//           const top = activeMediaRect.top + window.scrollY;
//           window.scrollTo({ top: top, behavior: 'smooth' });
//         });

//         this.playActiveMedia(activeMedia);

//         if (!this.elements.thumbnails) return;
//         const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
//         this.setActiveThumbnail(activeThumbnail);
//         this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
//       }

//       setActiveThumbnail(thumbnail) {
//         if (!this.elements.thumbnails || !thumbnail) return;

//         this.elements.thumbnails
//           .querySelectorAll('button')
//           .forEach((element) => element.removeAttribute('aria-current'));

//         thumbnail.querySelector('button').setAttribute('aria-current', true);

//         if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

//         if (this.isVerticalScroll) {
//           this.elements.thumbnails.slider.scrollTo({ top: thumbnail.offsetTop });
//         } else {
//           this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
//         }
//       }

//       announceLiveRegion(activeItem, position) {
//         const image = activeItem.querySelector('.product__modal-opener--image img');
//         if (!image) return;
//         image.onload = () => {
//           this.elements.liveRegion.setAttribute('aria-hidden', false);
//           this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
//           setTimeout(() => {
//             this.elements.liveRegion.setAttribute('aria-hidden', true);
//           }, 2000);
//         };
//         image.src = image.src;
//       }

//       playActiveMedia(activeItem) {
//         window.pauseAllMedia();

//         const deferredMedia = activeItem.querySelector('.deferred-media');
//         if (deferredMedia) {
//           deferredMedia.loadContent(false);
//         }
//       }

//       preventStickyHeader() {
//         this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
//         if (!this.stickyHeader) return;
//         this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
//       }

//       removeListSemantic() {
//         if (!this.elements.viewer.slider) return;
//         this.elements.viewer.slider.setAttribute('role', 'presentation');
//         this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
//       }
//     }
//   );
// }

// if (!customElements.get('media-gallery')) {
//   customElements.define(
//     'media-gallery',
//     class MediaGallery extends HTMLElement {
//       constructor() {
//         super();
//         this.elements = {
//           liveRegion: this.querySelector('[id^="GalleryStatus"]'),
//           viewer: this.querySelector('[id^="GalleryViewer"]'),
//           thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
//           productMedia: this.querySelector('.product__media') // Reference to the product__media element
//         };

//         this.isVerticalScroll = this.classList.contains('vertical-scroll') && window.innerWidth >= 1025 && !this.closest('.quick-add-modal');

//         if (!this.elements.thumbnails || !this.elements.productMedia) return;

//         this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));

//         this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
//           mediaToSwitch.querySelector('button')
//             .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target));
//         });

//         if (this.dataset.desktopLayout.includes('thumbnail') && this.isVerticalScroll) this.removeListSemantic();

//         // === Enable mouse wheel scrolling on thumbnails ===
//         const slider = this.elements.thumbnails.slider;
//         if (slider) {
//           if (this.isVerticalScroll) {
//             // Vertical thumbnails: normal vertical scroll
//             slider.addEventListener('wheel', (e) => {
//               e.preventDefault();
//               slider.scrollTop += e.deltaY;
//             });
//           } else {
//             // Horizontal thumbnails: vertical wheel scroll mapped to horizontal
//             slider.addEventListener('wheel', (e) => {
//               e.preventDefault();
//               slider.scrollLeft += e.deltaY;
//             });
//           }
//         }

//         // Adjust thumbnail height dynamically based on the product__media height
//         this.adjustThumbnailHeight();
//         window.addEventListener('resize', this.adjustThumbnailHeight.bind(this));
//       }

//       // Adjust the height of the thumbnails based on the product__media height
//       adjustThumbnailHeight() {
//         const productMediaHeight = this.elements.productMedia.offsetHeight; // Get the height of the product__media container
//         const thumbnailItems = this.elements.thumbnails.querySelectorAll('.thumbnail-list__item');
        
//         // Ensure enough space for all 4 thumbnails, and avoid cutting off the 4th one
//         const thumbnailHeight = Math.floor(productMediaHeight / 4); // Equal height for 4 thumbnails

//         // Set all thumbnails to the calculated height
//         thumbnailItems.forEach((item) => {
//           item.style.height = `${thumbnailHeight}px`;
//         });

//         // Ensure thumbnails container allows for scrolling if necessary
//         const thumbnailsContainer = this.elements.thumbnails;
//         thumbnailsContainer.style.maxHeight = `${productMediaHeight}px`;
//         thumbnailsContainer.style.overflowY = 'auto';
//       }

//       onSlideChanged(event) {
//         const thumbnail = this.elements.thumbnails.querySelector(
//           `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
//         );
//         this.setActiveThumbnail(thumbnail);
//       }

//       setActiveMedia(mediaId) {
//         const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) || this.elements.viewer.querySelector('[data-media-id]');

//         if (!activeMedia) return;

//         this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
//           element.classList.remove('is-active');
//         });
//         activeMedia?.classList?.add('is-active');

//         this.preventStickyHeader();

//         window.setTimeout(() => {
//           if (this.isVerticalScroll) {
//             activeMedia.parentElement.scrollTo({ top: activeMedia.offsetTop });
//           } else {
//             activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
//           }
//           const activeMediaRect = activeMedia.getBoundingClientRect();
//           if (activeMediaRect.top > -0.5) return;
//           const top = activeMediaRect.top + window.scrollY;
//           window.scrollTo({ top: top, behavior: 'smooth' });
//         });
        
//         this.playActiveMedia(activeMedia);

//         if (!this.elements.thumbnails) return;
//         const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
//         this.setActiveThumbnail(activeThumbnail);
//         this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
//       }

//       setActiveThumbnail(thumbnail) {
//         if (!this.elements.thumbnails || !thumbnail) return;

//         this.elements.thumbnails
//           .querySelectorAll('button')
//           .forEach((element) => element.removeAttribute('aria-current'));
          
//         thumbnail.querySelector('button').setAttribute('aria-current', true);

//         if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

//         if (this.isVerticalScroll) {
//           this.elements.thumbnails.slider.scrollTo({ top: thumbnail.offsetTop });
//         } else {
//           this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
//         }
//       }

//       announceLiveRegion(activeItem, position) {
//         const image = activeItem.querySelector('.product__modal-opener--image img');
//         if (!image) return;
//         image.onload = () => {
//           this.elements.liveRegion.setAttribute('aria-hidden', false);
//           this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
//           setTimeout(() => {
//             this.elements.liveRegion.setAttribute('aria-hidden', true);
//           }, 2000);
//         };
//         image.src = image.src;
//       }

//       playActiveMedia(activeItem) {
//         window.pauseAllMedia();

//         const deferredMedia = activeItem.querySelector('.deferred-media');
//         if (deferredMedia) {
//           deferredMedia.loadContent(false);
//         }
//       }

//       preventStickyHeader() {
//         this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
//         if (!this.stickyHeader) return;
//         this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
//       }

//       removeListSemantic() {
//         if (!this.elements.viewer.slider) return;
//         this.elements.viewer.slider.setAttribute('role', 'presentation');
//         this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
//       }
//     }
//   );
// }

// if (!customElements.get('media-gallery')) {
//   customElements.define(
//     'media-gallery',
//     class MediaGallery extends HTMLElement {
//       constructor() {
//         super();
//         this.elements = {
//           liveRegion: this.querySelector('[id^="GalleryStatus"]'),
//           viewer: this.querySelector('[id^="GalleryViewer"]'),
//           thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
//           productMedia: this.querySelector('.product__media')
//         };

//         this.isVerticalScroll = this.classList.contains('vertical-scroll') && window.innerWidth >= 1025 && !this.closest('.quick-add-modal');

//         if (!this.elements.thumbnails || !this.elements.productMedia) return;

//         this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));

//         this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
//           mediaToSwitch.querySelector('button')
//             .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target));
//         });

//         if (this.dataset.desktopLayout.includes('thumbnail') && this.isVerticalScroll) this.removeListSemantic();

//         // === Enable touchpad two-finger scrolling on thumbnails ===
//         const slider = this.elements.thumbnails.slider;
//       //   if (slider) {
//       //   let isScrolling = false;
//       //   let scrollDelta = 0;

//       //   slider.addEventListener('wheel', (e) => {
//       //     e.preventDefault();

//       //     scrollDelta += e.deltaY; // accumulate scroll
//       //     if (!isScrolling) {
//       //       isScrolling = true;
//       //       requestAnimationFrame(() => {
//       //         if (this.isVerticalScroll) {
//       //           slider.scrollTop += scrollDelta;
//       //         } else {
//       //           slider.scrollLeft += scrollDelta;
//       //         }
//       //         scrollDelta = 0;
//       //         isScrolling = false;
//       //       });
//       //     }
//       //   }, { passive: false });
//       // }


//         // Adjust thumbnail height dynamically based on the product__media height
//         this.adjustThumbnailHeight();
//         window.addEventListener('resize', this.adjustThumbnailHeight.bind(this));
//       }

//       adjustThumbnailHeight() {
//         const productMediaHeight = this.elements.productMedia.offsetHeight;
//         const thumbnailItems = this.elements.thumbnails.querySelectorAll('.thumbnail-list__item');
//         const thumbnailHeight = Math.floor(productMediaHeight / 4);

//         thumbnailItems.forEach((item) => {
//           item.style.height = `${thumbnailHeight}px`;
//         });

//         const thumbnailsContainer = this.elements.thumbnails;
//         thumbnailsContainer.style.maxHeight = `${productMediaHeight}px`;
//         thumbnailsContainer.style.overflowY = 'auto';
//       }

//       onSlideChanged(event) {
//         const thumbnail = this.elements.thumbnails.querySelector(
//           `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
//         );
//         this.setActiveThumbnail(thumbnail);
//       }

//       setActiveMedia(mediaId) {
//         const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) || this.elements.viewer.querySelector('[data-media-id]');
//         if (!activeMedia) return;

//         this.elements.viewer.querySelectorAll('[data-media-id]').forEach((el) => el.classList.remove('is-active'));
//         activeMedia?.classList?.add('is-active');

//         this.preventStickyHeader();

//         window.setTimeout(() => {
//           if (this.isVerticalScroll) {
//             activeMedia.parentElement.scrollTo({ top: activeMedia.offsetTop });
//           } else {
//             activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
//           }
//           const activeMediaRect = activeMedia.getBoundingClientRect();
//           if (activeMediaRect.top > -0.5) return;
//           const top = activeMediaRect.top + window.scrollY;
//           window.scrollTo({ top: top, behavior: 'smooth' });
//         });

//         this.playActiveMedia(activeMedia);

//         if (!this.elements.thumbnails) return;
//         const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
//         this.setActiveThumbnail(activeThumbnail);
//         this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
//       }

//       setActiveThumbnail(thumbnail) {
//         if (!this.elements.thumbnails || !thumbnail) return;

//         this.elements.thumbnails
//           .querySelectorAll('button')
//           .forEach((el) => el.removeAttribute('aria-current'));
          
//         thumbnail.querySelector('button').setAttribute('aria-current', true);

//         if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

//         if (this.isVerticalScroll) {
//           this.elements.thumbnails.slider.scrollTo({ top: thumbnail.offsetTop });
//         } else {
//           this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
//         }
//       }

//       announceLiveRegion(activeItem, position) {
//         const image = activeItem.querySelector('.product__modal-opener--image img');
//         if (!image) return;
//         image.onload = () => {
//           this.elements.liveRegion.setAttribute('aria-hidden', false);
//           this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
//           setTimeout(() => {
//             this.elements.liveRegion.setAttribute('aria-hidden', true);
//           }, 2000);
//         };
//         image.src = image.src;
//       }

//       playActiveMedia(activeItem) {
//         window.pauseAllMedia();

//         const deferredMedia = activeItem.querySelector('.deferred-media');
//         if (deferredMedia) deferredMedia.loadContent(false);
//       }

//       preventStickyHeader() {
//         this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
//         if (!this.stickyHeader) return;
//         this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
//       }

//       removeListSemantic() {
//         if (!this.elements.viewer.slider) return;
//         this.elements.viewer.slider.setAttribute('role', 'presentation');
//         this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
//       }
//     }
//   );
// }


if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
          productMedia: this.querySelector('.product__media')
        };

        this.isVerticalScroll = this.classList.contains('vertical-scroll') && window.innerWidth >= 1025 && !this.closest('.quick-add-modal');
        this.userScrolling = false; // track active scroll or drag

        if (!this.elements.thumbnails || !this.elements.productMedia) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));

        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch.querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target));
        });

        if (this.dataset.desktopLayout.includes('thumbnail') && this.isVerticalScroll) this.removeListSemantic();

        const slider = this.elements.thumbnails.slider;
        if (slider) {
          slider.style.scrollBehavior = 'smooth';
          slider.style.cursor = 'grab';
          slider.style.overflowX = 'auto';
          slider.style.overflowY = 'auto';

          // --- Drag to scroll ---
          let isDown = false;
          let startX, startY;
          let scrollLeft, scrollTop;

          slider.addEventListener('mousedown', (e) => {
            isDown = true;
            this.userScrolling = true;
            slider.classList.add('active');
            startX = e.pageX - slider.offsetLeft;
            startY = e.pageY - slider.offsetTop;
            scrollLeft = slider.scrollLeft;
            scrollTop = slider.scrollTop;
          });

          slider.addEventListener('mouseleave', () => {
            isDown = false;
            slider.classList.remove('active');
            this.userScrolling = false;
          });

          slider.addEventListener('mouseup', () => {
            isDown = false;
            slider.classList.remove('active');
            this.userScrolling = false;
          });

          slider.addEventListener('mousemove', (e) => {
            if (!isDown) return;
            e.preventDefault();
            this.userScrolling = true;
            const x = e.pageX - slider.offsetLeft;
            const y = e.pageY - slider.offsetTop;
            const walkX = (x - startX);
            const walkY = (y - startY);

            if (this.isVerticalScroll) {
              slider.scrollTop = scrollTop - walkY;
            } else {
              slider.scrollLeft = scrollLeft - walkX;
            }
          });

          // --- Mouse wheel / two-finger scroll ---
          let scrollTimeout;
          const scrollSpeed = 1.5;

          slider.addEventListener('wheel', (e) => {
            e.preventDefault();
            this.userScrolling = true;

            clearTimeout(scrollTimeout);
            scrollTimeout = setTimeout(() => {
              this.userScrolling = false;
            }, 100);

            let delta = e.deltaY;
            if (e.deltaMode === 1) delta *= 15; // lines -> pixels
            delta *= scrollSpeed;

            if (this.isVerticalScroll) {
              slider.scrollTop += delta;
            } else {
              slider.scrollLeft += delta;
            }
          }, { passive: false });
        }

        // Adjust thumbnail height dynamically
        this.adjustThumbnailHeight();
        window.addEventListener('resize', this.adjustThumbnailHeight.bind(this));
      }

      adjustThumbnailHeight() {
        const productMediaHeight = this.elements.productMedia.offsetHeight;
        const thumbnailItems = this.elements.thumbnails.querySelectorAll('.thumbnail-list__item');
        const thumbnailHeight = Math.floor(productMediaHeight / 4);

        thumbnailItems.forEach((item) => {
          item.style.height = `${thumbnailHeight}px`;
        });

        const thumbnailsContainer = this.elements.thumbnails;
        thumbnailsContainer.style.maxHeight = `${productMediaHeight}px`;
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId) {
        const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) || this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) return;

        this.elements.viewer.querySelectorAll('[data-media-id]').forEach(el => el.classList.remove('is-active'));
        activeMedia.classList.add('is-active');

        this.preventStickyHeader();

        window.setTimeout(() => {
          if (this.isVerticalScroll) {
            activeMedia.parentElement.scrollTo({ top: activeMedia.offsetTop });
          } else {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
        });

        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails.querySelectorAll('button').forEach(el => el.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);

        // Scroll into view only if user is not actively scrolling
        if (!this.userScrolling && !this.elements.thumbnails.isSlideVisible(thumbnail, 10)) {
          thumbnail.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
        }
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
      }

      showNextSlide() {
        const current = this.elements.viewer.querySelector('.is-active');
        const next = current?.nextElementSibling || current;
        this.setActiveMedia(next?.dataset.mediaId);
      }

      showPrevSlide() {
        const current = this.elements.viewer.querySelector('.is-active');
        const prev = current?.previousElementSibling || current;
        this.setActiveMedia(prev?.dataset.mediaId);
      }
    }
  );
}
